module.exports = __webpack_public_path__ + "img/手机APP.6bae7c96.png";